import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CreateGrillePage } from "@/features/ventes/components/tarifs/CreateGrillePage";

export const Route = createFileRoute("/_app/ventes/tarifs/create")({
  loader: requirePermission(PERMISSIONS.VENTES.TARIFS.CREATE),
  staticData: {
    title: "Nouvelle grille tarifaire",
    showInBreadcrumb: true,
  },
  component: CreateGrillePage,
});
